<template>
  <v-row justify="center">
    <v-dialog v-model="visible" persistent max-width="600px">
      <v-form ref="form" @submit.prevent="handleSubmit">
        <v-card :loading="loading">
          <v-card-title>
            <span class="headline">{{
              $t("modal.updatePaymentMethod.title")
            }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-alert
                v-if="error"
                border="left"
                colored-border
                type="error"
                elevation="2"
                >{{ error }}</v-alert
              >

              <!-- card -->
              <StripeElements
                :stripe-key="getStripePK"
                #default="{ elements }"
                ref="elms"
              >
                <StripeElement
                  type="card"
                  class="stripeCard"
                  :elements="elements"
                  ref="card"
                  :class="{ cardComplete, inputError: cardErrorMessage }"
                  @change="cardChanged($event)"
                />
              </StripeElements>

              <!-- <card
                class="stripeCard"
                :class="{ cardComplete, inputError: cardErrorMessage }"
                :stripe="getStripePK"
                @change="cardChanged($event)"
                :options="this.stripeOptions"
              /> -->
              <p class="cardError" v-if="this.cardErrorMessage">
                {{ cardErrorMessage }}
              </p>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="blue darken-1" text @click="onCancel">{{
              $t("label.cancel")
            }}</v-btn>
            <v-btn color="blue darken-1" type="submit" :disabled="loading">{{
              $t("label.save")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
import { StripeElements, StripeElement } from "vue-stripe-elements-plus";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "UpdatePaymentMethod",
  components: { StripeElement, StripeElements },
  computed: {
    ...mapGetters(["getStripePK"]),
  },
  data() {
    return {
      loading: false,
      cardComplete: false,
      error: "",
      cardErrorMessage: "",
      stripeOptions: {
        style: {
          base: {
            color: "rgba(0, 0, 0, 0.54)",
            fontFamily: '"Roboto", sans-serif',
            fontSmoothing: "antialiased",
            fontSize: "16px",
            "::placeholder": {
              color: "rgba(0, 0, 0, 0.54)",
            },
          },
          invalid: {
            color: "#fa755a",
            iconColor: "#fa755a",
            fontFamily: '"Roboto", sans-serif',
          },
        },
      },
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...mapActions(["updatePaymentMethod"]),
    onCancel() {
      this.$emit("onCancelled");
      this.error = null;
    },
    cardChanged(event) {
      if (event.error) {
        this.cardErrorMessage = event.error.message;
        this.cardComplete = false;
      } else {
        this.cardErrorMessage = null;
        this.cardComplete = true;
      }
    },
    handleSubmit() {
      if (this.cardComplete) {
        this.loading = true;
        
        const groupComponent = this.$refs.elms;
        const cardComponent = this.$refs.card;
        const cardElement = cardComponent.stripeElement;
        
        groupComponent.instance.createToken(cardElement)
          .then((resp) => {
            var req = {};
            req.token = resp.token.id;
            this.updatePaymentMethod(req)
              .then(() => {
                this.$emit("onConfirmed");
                cardElement.clear();
              })
              .catch(() => {
                this.error = this.$t("modal.updatePaymentMethod.cardError");
                return;
              })
              .finally(() => {
                this.loading = false;
              });
          })
          .catch(() => {
            this.error = this.$t("modal.updatePaymentMethod.cardError");
            return;
          });
      } else {
        if (!this.cardErrorMessage) {
          this.cardErrorMessage = "Please enter your card number.";
          return;
        }
      }
    },
  },
  created: function () {},
};
</script>

<style>
.cardError {
  color: red;
  line-height: 20px;
  font-size: 12px;
}
.stripeCard {
  border-style: solid;
  padding: 5px;
  border-width: 0 0 1px;
  border-color: rgba(0, 0, 0, 0.4);
}
.inputError {
  border-color: red !important;
}
</style>